const worker_housing_data = {
  title: `Worker Housing Profiles`,
  body: `Select the Worker Housing Profiles to add to Addendum B.`,
  table: {
    th: ["Type of Housing", "State", "County"],
    td: [
      "workerHousing_type_of_housing",
      "workerHousing_state",
      "workerHousing_county",
    ],
  },
  new_profile(profile) {
    return {
      id: profile.id,
      workerHousing_type_of_housing: profile.workerHousing_type_of_housing,
      workerHousing_state: profile.workerHousing_state,
      workerHousing_county: profile.workerHousing_county,
    };
  },
};

export default worker_housing_data;
